import PropTypes from 'prop-types'
import React from 'react'

import { RadioInput } from '../../components'

import AddressDisplay from './AddressDisplay'

import { AddressShape } from './propTypes'

const r = {
  margin: 'auto',
  paddingTop: 7,
  paddingLeft: 10,
  paddingRight: 10,
  paddingBottom: 7
}

let ActiveAddressInAddressSelectorList = (
  {
    address,
    isSelected,
    onSelected,
    onRadioSelected,
    onBeginEdit,
    onDelete,
    selectAddressMessage,
    translationUtility
  }) => (
    <div
      className='row'
      style={{ borderRadius: 4, borderWidth: 1, borderStyle: 'solid', borderColor: '#ddd' }}
    >
      <div className='col-1' style={{ marginTop: 8, paddingLeft: 8 }}>
      <RadioInput selected={isSelected} onClick={() => onRadioSelected(address.Id)} />
      </div>
      <div className='col-11'>
        <AddressDisplay address={address} compact={false} translationUtility={translationUtility} />
      </div>
      <div style={r}>
        <a
          href=''
          className='btn btn-info'
          onClick={(e) => e.preventDefault() || onSelected(address.Id)}
        >
          {selectAddressMessage}
        </a>
      </div>

    <div style={r} style={{ display: 'none' }}>
        <a href='' className='btn btn-default'
            onClick={(e) => e.preventDefault() || onBeginEdit(address.Id)}
        >
            Edit
        </a>

        <a href='' className='btn btn-default'
            onClick={(e) => e.preventDefault() || onDelete(address.Id)}
        >
            Delete
        </a>
    </div>
  </div>
)

ActiveAddressInAddressSelectorList.propTypes = {
  address: PropTypes.shape(AddressShape).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelected: PropTypes.func.isRequired,
  onRadioSelected: PropTypes.func.isRequired,
  onBeginEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  selectAddressMessage: PropTypes.string.isRequired
}

export default ActiveAddressInAddressSelectorList


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Address/ActiveAddressInAddressSelectorList.jsx